import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, TextField, Image } from "components";
import { Button } from "egov-ui-framework/ui-atoms";
import { CityPicker } from "modules/common";
import Label from "egov-ui-kit/utils/translationNode";
import logoImage from "egov-ui-kit/assets/images/logoImage.png";
import "./index.css";
const EyeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
      stroke="#666"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="3" stroke="#666" strokeWidth="2" />
  </svg>
);
const EyeOffIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.94 17.94A10.94 10.94 0 0112 20c-7 0-11-8-11-8a20.29 20.29 0 015.06-6.06M9.9 4.24A10.4 10.4 0 0112 4c7 0 11 8 11 8a20.32 20.32 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"
      stroke="#666"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line x1="1" y1="1" x2="23" y2="23" stroke="#666" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
const LoginForm = ({ handleFieldChange, form, onForgotPasswdCLick, logoUrl }) => {
  const [showPassword, setShowPassword] = useState(false);
  const fields = form.fields || {};
  const submit = form.submit;
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Card
      className="login-card-wrapper user-screens-card col-lg-offset-4 col-lg-4 col-md-offset-4 col-md-4 col-sm-offset-4 col-sm-4"
      textChildren={
        <div>
          <div className="rainmaker-displayInline login-form-screen" style={{ justifyContent: "center", alignItems: "center", marginBottom: "24px" }}>
            <div className="all-login-logo">
              <Image
                className="mseva-logo"
                // source={logoUrl?logoUrl:`${logo}`}
                source={logoImage}
                // source="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Seal_of_Uttar_Pradesh.svg/1024px-Seal_of_Uttar_Pradesh.svg.png"
              />
            </div>
            {/* <div style={{marginLeft:"7px"}}>
          <Label bold={true}  fontSize= "23px" label="|" />
          </div> */}
            {/* <div style={{ marginTop: '55px' }}>
              <Label bold={true} color="black" fontSize="24px" label="STATE_LABEL" />
            </div> */}
          </div>
          <div style={{ marginTop: "52px" }}>
            <Label style={{ marginBottom: "12px" }} className="text-center" bold={true} dark={true} fontSize={16} label="CORE_COMMON_LOGIN" />
          </div>
          <TextField onChange={(e, value) => handleFieldChange("username", value)} {...fields.username} />
          {/* <TextField
            onKeyDown={(e) => {
              if (/\s/.test(e.key)) {
                e.preventDefault();
              }
            }}
            onChange={(e, value) => handleFieldChange("password", value)}
            {...fields.password}
          /> */}
          


          {/* Password field with eye toggle */}
          <div style={{ position: "relative" }}>
            <TextField
               {...fields.password}
              type={showPassword ? "text" : "password"}
              onKeyDown={(e) => {
                if (/\s/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              onChange={(e, value) => handleFieldChange("password", value)}
           
            />
            <span
              onClick={togglePasswordVisibility}
              style={{
                position: "absolute",
                right: "12px",
                top: "33px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              {showPassword ? <EyeOffIcon /> : <EyeIcon />}
            </span>
          </div>

          <div className="citypicker-style forgot-password-citypicker">
            <CityPicker onChange={handleFieldChange} fieldKey="city" field={fields.city} tabIndex={0} />
          </div>

          <div className="remeber-me-sec">
            <div>
              {/* <Label
                containerStyle={{ cursor: "pointer", position: "relative", zIndex: 10 }}
                labelStyle={{ marginBottom: "12px" }}
                className="forgot-passwd"
                fontSize={14}
                label="Remember Me"
              /> */}
              {/* <div className="mb-3 form-check">
                <input type="checkbox" className="form-check-input" id="rememberMe" />
                <label className="form-check-label" for="rememberMe">
                  Remember Me
                </label>
              </div> */}
            </div>

            <Link to="/forgot-password" style={{ display: "block" }}>
              <div>
                <Label
                  containerStyle={{ cursor: "pointer", position: "relative", zIndex: 10 }}
                  labelStyle={{ marginBottom: "12px" }}
                  className="forgot-passwd"
                  fontSize={14}
                  label="FORGOT PASSWORD?"
                />
              </div>
            </Link>
          </div>

          <Button
            {...submit}
            className="common-all-btn"
            style={{
              height: "48px",
              width: "100%",
            }}
            variant={"contained"}
            color={"primary"}
          >
            <Label buttonLabel={true} labelStyle={{ fontWeight: 500 }} label="CONTINUE" />
          </Button>
          {/* <Button {...submit} fullWidth={true} primary={true} /> */}
        </div>
      }
    />
  );
};

export default LoginForm;



// WEBPACK FOOTER //
// src/modules/employee/User/Login/components/LoginForm/index.js